import React, { useEffect, useState } from "react";
import LoaderArticle from "../../components/loader/article/LoaderArticle.jsx";
import ArticlesParCategorie from "../../components/article/ArticlesParCategorie";
import ArticleBanner from "../../components/article/ArticleBanner";
import useArticles from "../../hooks/useArticle.js";
import "../../assets/css/article/Articles.css";
import ArticleAucunResultat from "../../components/article/ArticleAucunResultat.jsx";
import LoaderDetailAnnonce from "../../components/loader/article/LoaderDetailAnnonce.jsx";

const Articles = () => {
  const { loadingArticle, setLoadingArticle, findAllArticlesGrouped } = useArticles();
  const [grouped, setGrouped] = useState([]);
  const [loadingVersDetails, setLoadingVersDetails] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      const data = await findAllArticlesGrouped(1, {
        status: 1,
        archive: 2,
        // userStatus: 1,
        userActive: 1,
        userArchive: 2,
        // dateExpirationAfter: new Date().toISOString(),
        isAdminGet: 0,
        adminApprouved: 1,
        excludeTest: 1,
      });
      setGrouped(data);
    };
    fetchData();
  }, []);

  if (loadingArticle) {
    return (
      <div className="container">
        <LoaderArticle />
      </div>
    );
  }

  if (loadingVersDetails) {
    return (
      <div className="container">
        <LoaderDetailAnnonce />
      </div>
    );
  }

  return (
    <div
      className="container"
      style={{ marginTop: "20px", marginBottom: "50px" }}
    >
      <ArticleBanner />
      {grouped && grouped.length > 0 ? (
        grouped.map((group) => (
          <ArticlesParCategorie
            key={group.category._id}
            category={group.category}
            articles={group.articles}
            setLoadingVersDetails={setLoadingVersDetails}
          />
        ))
      ) : (
        <ArticleAucunResultat />
      )}
    </div>
  );
};

export default Articles;
